import {
  IDepdendencyInput,
  IErrorInput,
  IEventInput,
  IRequestInput,
  IPageViewInput,
} from '../../constants/reporterServiceInputs';
import Consent from '../../utils/Consent';

export default abstract class Driver {
  protected consent: Consent;

  abstract activate(consent: Consent): void;

  abstract logError(error: IErrorInput): void;

  abstract trackEvent(event: IEventInput): void;

  abstract trackRequest(request: IRequestInput): void;

  abstract trackDependency(dependencyInput: IDepdendencyInput): void;

  abstract trackPageView(pageView: IPageViewInput): void;
}
